/**
 * api 对应后台的接口文件
 */
import shiroApi from './mod/shiroApi'
import userApi from '@/api/mod/userApi'
import fileApi from '@/api/mod/fileApi'
import pagesetApi from '@/api/mod/pagesetApi'
import systemApi from './mod/systemApi'
import dicApi from './mod/dicApi'
import goodsApi from './mod/goodsApi'
import orderApi from '@/api/mod/orderApi'
let urlObj = {
  shiroApi,
  userApi,
  fileApi,
  pagesetApi,
  systemApi,
  dicApi,
  goodsApi,
  orderApi,
}

// 是否添加模块前缀
let api = {}
let isOPenPrefix = process.env.VUE_APP_OPEN_PREFIX || 'true'
for (const key in urlObj) {
  if (Object.hasOwnProperty.call(urlObj, key)) {
    const element = urlObj[key]
    let prefix = element.prefix
    let url = element.url
    api[key] = {}
    for (const k in url) {
      api[key][k] = isOPenPrefix === 'true' ? '/' + prefix + url[k] : url[k]
    }
  }
}

export default api
